import { Iorganization } from "types/bussines";
import { create } from "zustand";

interface IBulkUploadOrdersState {
    selectedOrganization?: Iorganization;
    selectedPaymentAgreement?: number;
    selectedDocument?: string;
    setSelectedOrganization: (organization?: Iorganization) => void;
    setSelectedPaymentAgreement: (paymentAgreement?: number) => void;
    setSelectedDocument: (document?: string) => void;
}

const useBulkUploadOrdersState = create<IBulkUploadOrdersState>(set => ({
    selectedOrganization: undefined,
    selectedPaymentAgreement: undefined,
    selectedDocument: undefined,
    setSelectedOrganization: (organization) => set({ selectedOrganization: organization }),
    setSelectedPaymentAgreement: (paymentAgreement) => set({ selectedPaymentAgreement: paymentAgreement }),
    setSelectedDocument: (document) => set({ selectedDocument: document }),
}));

export default useBulkUploadOrdersState;